export const TLC_REQUEST = "TLC_REQUEST"
export const TLC_SUCCESS = "TLC_SUCCESS"
export const TLC_ERROR = "TLC_ERROR"
export const RESET_PAYMENT_STORE = "RESET_PAYMENT_STORE"
export const [PRICE_SUCCESS] = [
  "PRICE_SUCCESS",
]
export const PAYMENT_REQUIRES_ACTION = "PAYMENT_REQUIRES_ACTION"

export const SETUP_PAYMENT_INTENT_REQUEST = "SETUP_PAYMENT_INTENT_REQUEST"

export const SETUP_PAYMENT_INTENT_SUCCESS = "SETUP_PAYMENT_INTENT_SUCCESS";
export const GET_CALL_PRICE = "GET_CALL_PRICE"
